import Automobiles from './assets/Automobiles-transformed.jpeg';
import BikingHikingGears from './assets/BikingHikingGears-transformed.jpeg';
import Books from './assets/Books-transformed.jpeg';
import CameraLenseses from './assets/CameraLenseses-transformed.jpeg';
import ConstructionMachinesManpower from './assets/ConstructionMachinesManpower-transformed.jpeg';
import Drones from './assets/Drones-transformed.jpeg';
import Electronics from './assets/Electronics-transformed.jpeg';
import Events from './assets/Events-transformed.jpeg';
import FitnessSportsEquipment from './assets/FitnessSportsEquipment-transformed.jpeg';
import Furniture from './assets/Furniture-transformed.jpeg';
import Gardening from './assets/Gardening-transformed.jpeg';
import Generators from './assets/Generators-transformed.jpeg';
import HomeAppliance from './assets/HomeAppliance-transformed.jpeg';
import Jewellery from './assets/Jewellery-transformed.jpeg';
import KidsUtilities from './assets/KidsUtilities-transformed.jpeg';
import MedicalEquipmentServices from './assets/MedicalEquipmentServices-transformed.jpeg';
import MobileWashrooms from './assets/MobileWashrooms-transformed.jpeg';
import MusicalInstruments from './assets/MusicalInstruments-transformed.jpeg';
import Others from './assets/Others-transformed.jpeg';
import PetsCareServices from './assets/PetsCareServices-transformed.jpeg';
import Property from './assets/Property-transformed.jpeg';
import SecurityEquipment from './assets/SecurityEquipment-transformed.jpeg';
import VendingMachine from './assets/VendingMachine-transformed.jpeg';
import Services from './assets/Services-transformed.jpeg';
import WeddingCouture from './assets/WeddingCouture-transformed.jpeg';
import MachinesTools from './assets/MachinesTools-transformed.jpeg';
import Costumes from './assets/costumes.png';
const categoriesImage = {
    "Automobiles": Automobiles,
    "Biking & Hiking Gears": BikingHikingGears,
    "Books": Books,
    "Costumes":  Costumes,  
    "Camera & Lenseses": CameraLenseses,
    "Construction Machines & Manpower": ConstructionMachinesManpower,
    "Drones": Drones,
    "Electronics": Electronics,
    "Events": Events,
    "Fitness & Sports Equipment": FitnessSportsEquipment,
    "Furniture": Furniture,
    "Gardening": Gardening,
    "Generators": Generators,
    "Home Appliance": HomeAppliance,
    "Jewellery": Jewellery,
    "Kids Utilities": KidsUtilities,
    "Medical Equipment & Services": MedicalEquipmentServices,
    "Mobile Washrooms": MobileWashrooms,
    "Musical Instruments": MusicalInstruments,
    "Others": Others,
    "Pets Care Services": PetsCareServices,
    "Property": Property,
    "Security Equipment": SecurityEquipment,
    "Vending Machine": VendingMachine,
    "Services" : Services,
    "Wedding Couture" : WeddingCouture,
    "Machines & Tools": MachinesTools,
};

export default categoriesImage;
